import {useSyncExternalStore} from "react";
import {billingSheetRequests, subscribeBillingSheetRequests} from "./billingSheetRequest";

/**
 * How many times the Billing sheet has been asked for from outside the top bar
 * (kitecorp/transferify-ui#3004), as the bar reads it. A thin adapter over the React-free
 * `./billingSheetRequest` store; the bar opens the sheet whenever the count moves. Zero on the server,
 * where nobody has pressed anything yet.
 */
export function useBillingSheetRequests(): number {
	return useSyncExternalStore(subscribeBillingSheetRequests, billingSheetRequests, () => 0);
}
